import React from 'react'
import PopupPlan from '~/components/PopupPlan'
import './style.scss'

class SelectPlan extends React.Component {

  render() {
    let plans = this.props.plans
    return (
      <div className="select-plans-container">
        <div className="plans">
          { plans.map( (p, i) => {
          return (
              <PopupPlan
                plan={p}
                key={i}
                selected={this.props.selected === i}
                onClick={ _ => this.props.selectPlan(i) } />
              )
          }) }
          
        </div>
        {window.settings.internalName === "supercrosslive" ?
        <div className="legal-texts">
          <p>Content available to ONLY outside USA + territories/possessions</p>
          <p>*Subscription Period ends June 30, 2019. ”Full Season” subscriptions are subject to auto-renewal</p>
        </div> : 
        <div className="legal-texts">
          <p>Upon cancellation, service access and use will end upon the completion of paid monthly or annual terms.<br />Service access will end immediately upon cancellation if during a free trial period.</p>
          <p>There is no refund for early termination of an annual plan.</p>
        </div>
        }
      </div>
    )
  }
}

export default SelectPlan;
